import styled, { css, keyframes } from 'styled-components'

import { cases } from '@subaio/utils'

import { type AnimationProps, AnimationStatus } from '../../useKeyedAnimation'
import type { Options } from './Options'

type Props = AnimationProps & Options

const animation = keyframes`
	0% {
		transform: translate(-50%, 100%);
	}
`

export const Container = styled.div<Props>`
	position: absolute;
	width: 100%;
	max-width: 480px;
	max-height: 80%;
	bottom: 0;
	left: 50%;
	transform-origin: bottom center;
	transform: translate(-50%, 0);

	overflow-y: auto;

	display: flex;
	flex-direction: column;
	gap: 16px;
	padding: 24px;

	color: ${({ textColor }) => textColor};
	background-color: ${({ backgroundColor }) => backgroundColor};;
	padding-top: 20px;

	box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 8px;

	border-radius: 8px 8px 0 0;
		${({ status, duration }) =>
			cases(status, {
				[AnimationStatus.Entering]: css`
				animation: ${duration}s ${animation};
			`,
				[AnimationStatus.Exiting]: css`
				animation: ${duration}s ${animation} reverse forwards;
			`,
			})}
`
